import {useCallback} from 'react';
import {useAppDispatch} from '../../../app/hooks/useAppDispatch';
import {popAssistantContent, pushAssistantContent, removeAssistantContent, setAssistantContent} from '../coreSlice';
import {AssistantContent} from '../types';

export const useAssistantUtils = () => {
  const dispatch = useAppDispatch();

  return {
    setAssistantContent: useCallback(
      (assistantContent: AssistantContent | null) => {
        dispatch(setAssistantContent(assistantContent));
      },
      [dispatch],
    ),
    popAssistantContent: useCallback(() => {
      dispatch(popAssistantContent());
    }, [dispatch]),
    pushAssistantContent: useCallback(
      (assistantContent: AssistantContent) => {
        const id = assistantContent.id ?? `${Math.random()}`;
        dispatch(pushAssistantContent({...assistantContent, id}));
        return () => {
          dispatch(removeAssistantContent(id));
        };
      },
      [dispatch],
    ),
    removeAssistantContent: useCallback(
      (id: string) => {
        dispatch(removeAssistantContent(id));
      },
      [dispatch],
    ),
  };
};
